import { render, staticRenderFns } from "./luckyRecord.vue?vue&type=template&id=27bb1c9a&scoped=true"
import script from "./luckyRecord.vue?vue&type=script&lang=js"
export * from "./luckyRecord.vue?vue&type=script&lang=js"
import style0 from "./luckyRecord.vue?vue&type=style&index=0&id=27bb1c9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bb1c9a",
  null
  
)

export default component.exports